import React, { useRef, useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import {
  addAndRemoveDisabledCls,
  addExternalScript,
  validateSubscriberData,
  submitFreeConsultationForm
} from "../../utils/utils";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SideBar = () => {
  const captchaKey = process.env.RECAPTCHA_SITE_KEY;
  const [sideBarName, setSideBarName] = useState("");
  const [sideBarEmail, setSideBarEmail] = useState("");
  const [sideBarPhone, setSideBarPhone] = useState("");
  const [sideBarSubject, setSideBarSubject] = useState("Software Patent");
  const [sideBarMessage, setSideBarMessage] = useState("");
  //
  const [captchaScriptLoaded, setCaptchaScriptLoaded] = useState(false);
  //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const submitSideBar = async (e) => {
    e?.preventDefault();
    if (
      sideBarName &&
      sideBarEmail &&
      sideBarSubject &&
      sideBarPhone &&
      sideBarMessage
    ) {
      //
      const token = window.captchaToken;
      if (!token) {
        alert("Please Confirm You Are Not a Robot!");
      } else {
          // call api
          const data = {
            recaptchaToken: token,
            email: sideBarEmail,
            name: sideBarName,
            phone: sideBarPhone,
            subject: sideBarSubject,
            message: sideBarMessage,
            site: "inventiv.org",
          };

          // validate data
          if (!validateSubscriberData(data)) {
            return;
          }

          // submit campagin
          submitFreeConsultationForm(data);

          // api
          fetch("https://api.trustyip.com/subcribers/add", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              accept: "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((response) => {
              alert(
                "Thank you for contacting us. We will be getting back to you shortly."
              );
            })
            .catch((err) => {
              alert("There is something wrong. Please try again later!");
            });
          // Add disabled class
          addAndRemoveDisabledCls("sideBarBtn");
      }
    } else {
      alert("Please fill in all fields.");
    }
  };
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const loadCaptchaScript = () => {
    if (!captchaScriptLoaded) {
      addExternalScript(
        "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
        () => {
          setCaptchaScriptLoaded(true);
        }
      );
    }
  };

  const renderReCaptch = () => {
    if (document.getElementById("re-captcha")) {
      window["grecaptcha"].render("re-captcha", {
        sitekey: captchaKey,
        callback: (response) => {
          window.captchaToken = response;
        },
      });
    }
  };
  useEffect(() => {
    // Google recaptcha
    window.captchaToken = "";
    window["onloadCallback"] = () => {
      renderReCaptch();
    };
  }, []);

  return (
    <>
      <div className="sidebar py-4 px-3">
        <h2 className="text-center" style={{ fontSize: "25px"}}>Get A Free Consultation</h2>
        <div>
          <Form>
            <Form.Group
              className="mb-1"
              controlId="sideBarName"
              value={sideBarName}
              onChange={(e) => setSideBarName(e.target.value)}
            >
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Your name"
                onFocus={loadCaptchaScript}
              />
            </Form.Group>

            <Form.Group
              className="mb-1"
              controlId="sideBarEmail"
              value={sideBarEmail}
              onChange={(e) => setSideBarEmail(e.target.value)}
            >
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Your email address"
                onFocus={loadCaptchaScript}
              />
            </Form.Group>

            <Form.Group
              className="mb-1"
              controlId="sideBarPhone"
              value={sideBarPhone}
              onChange={(e) => setSideBarPhone(e.target.value)}
            >
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Your phone"
                onFocus={loadCaptchaScript}
              />
            </Form.Group>

            <Form.Group className="mb-1" controlId="sideBarSubject">
              <Form.Label>What do you need help with?</Form.Label>
              <Form.Select
                aria-label="What do you need help with?"
                defaultValue={"Software Patent"}
                value={sideBarSubject}
                onChange={(e) => setSideBarSubject(e.target.value)}
                onFocus={loadCaptchaScript}
              >
                <option value="Software Patent" selected="true">
                  Software Patent
                </option>
                <option value="AI Patent">AI Patent</option>
                <option value="AR/VR Patent">AR/VR Patent</option>
                <option value="Communication Patent">
                  Communication Patent
                </option>
                <option value="Electronic Patent">Electronic Patent</option>
                <option value="Fin Tech Patent">Fin Tech Patent</option>Fin Tech
                Patent
                <option value="Industrial Design Patent">
                  Industrial Design Patent
                </option>
                <option value="Medical Device">Medical Device Patent</option>
                <option value="Mechanical Design">
                  Mechanical Design Patent
                </option>
                <option value="Trademark">Trademark</option>
              </Form.Select>
            </Form.Group>

            <Form.Group
              className="mb-1"
              controlId="sideBarMessage"
              value={sideBarMessage}
              onChange={(e) => setSideBarMessage(e.target.value)}
            >
              <Form.Label>How can we help you with?</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Your message"
                onFocus={loadCaptchaScript}
              />
            </Form.Group>
            <Form.Group className="mb-1">
              <div
                id="re-captcha"
                class="g-recaptcha"
                style={{ maxWidth: "250px" }}
              ></div>
              {/* <ReCAPTCHA sitekey="6LetH-InAAAAAOJxzG4oeh59AVKhM3nj4eCxXXBI" ref={captchaRef} /> */}
            </Form.Group>
            <span className="text-muted" style={{ fontSize: 10 + "px" }}>
              By submitting your agree with our Privacy Policy
            </span>
            <button
              id="sideBarBtn"
              className="btn btn-warning w-100 mt-1"
              onClick={(e) => submitSideBar(e)}
            >
              Submit
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SideBar;
